export const SET_VALUES = 'REFERENCE_FACTORS_SET_VALUES';
export const SET_INITIAL_VALUES = 'REFERENCE_FACTORS_SET_INITIAL_VALUES';

export const setValues = (values) => ({ type: SET_VALUES, values });
export const setInitialValues = () => ({ type: SET_INITIAL_VALUES });
